import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';

class CompanySettingsRoute extends Route {
  @service router;
  @service session;

  redirect() {
    const { company } = this.session.currentUser;

    if (company) {
      this.router.replaceWith('company-profile', company.id);
    } else {
      this.router.replaceWith('settings.profile');
    }
  }
}

export default CompanySettingsRoute;
